var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 81",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5625,
    width: 76,
    height: 76,
    rx: 38,
    stroke: "#9819C3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0012 58.207C37.0012 59.8639 38.3443 61.207 40.0012 61.207C41.658 61.207 43.0012 59.8639 43.0012 58.207V43.5602H57.6484C59.3053 43.5602 60.6484 42.217 60.6484 40.5602C60.6484 38.9033 59.3053 37.5602 57.6484 37.5602H43.0012V22.9129C43.0012 21.2561 41.658 19.9129 40.0012 19.9129C38.3443 19.9129 37.0012 21.2561 37.0012 22.9129V37.5602H22.3543C20.6975 37.5602 19.3543 38.9033 19.3543 40.5602C19.3543 42.217 20.6975 43.5602 22.3543 43.5602H37.0012V58.207Z",
    fill: "#9819C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus-button.eeed29594a93262e5aab156681cfb989.svg";
export { ForwardRef as ReactComponent };